import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useEvent } from '@emerald-works/react-event-bus-client'
import { userSlice } from '../../reducers'
import { useAlert } from '../../hooks'
import { RemovedAlert, AddedAlert } from './alerts'

const useAddToBookmarks = ({ from } = {}) => {
  const [activeArticle, setActiveArticle] = useState([])
  const dispatch = useDispatch()

  const { enqueueMsg, enqueueAlert } = useAlert()

  const bookmarkedContent = useSelector(
    userSlice.selectors.selectBookmarkedContentIds
  )

  const loading = useSelector(userSlice.selectors.selectLoadingBookmarked)

  const [insertBookmark] = useEvent([
    {
      eventName: 'bookmarksInsert',
      onSuccess: payload => {
        setActiveArticle(items =>
          items.filter(({ locationId }) => locationId !== payload.content.sk)
        )
        dispatch(userSlice.actions.addBookmarked({ id: payload.content.sk, createdAt: new Date().toISOString() }))
        enqueueAlert(<AddedAlert />)
      },
      onError: payload => {
        const sent = payload.error?.sent || payload?.sent
        if (sent.item) {
          setActiveArticle(items =>
            items.filter(
              ({ locationId }) => locationId !== sent.item
            )
          )
        } else setActiveArticle([])
        enqueueMsg('Unable to add to bookmarks', 'error')
      }
    }
  ])

  const [removeBookmark] = useEvent([
    {
      eventName: 'bookmarksRemove',
      onSuccess: payload => {
        setActiveArticle(items =>
          items.filter(({ locationId }) => locationId !== payload.item)
        )
        dispatch(userSlice.actions.removeBookmarked(payload.item))
        enqueueAlert(<RemovedAlert />)
      },
      onError: payload => {
        const sent = payload.error?.sent || payload?.sent
        if (sent?.item) {
          setActiveArticle(items =>
            items.filter(
              ({ locationId }) => locationId !== sent.item
            )
          )
        } else setActiveArticle([])
        enqueueMsg('Unable to remove from bookmarks', 'error')
      }
    }
  ])

  const isBookmarked = content =>
    content ? bookmarkedContent.some(b => b.id === content.locationId) : false

  const handleAddBookmark = ({ locationId: contentId }) => {
    insertBookmark.trigger({ contentId, from })
  }

  const handleRemoveBookmark = ({ locationId: contentId }) => {
    removeBookmark.trigger({ contentId, from })
  }

  const handleBookmark = article => {
    setActiveArticle([...activeArticle, article])
    isBookmarked(article)
      ? handleRemoveBookmark(article)
      : handleAddBookmark(article)
  }

  const bookmarking = (item) => {
    if (!item?.locationId) return false
    return (activeArticle.length > 0 &&
      activeArticle.findIndex(x => x.locationId === item.locationId) >= 0) ||
    loading
  }

  return { isBookmarked, handleBookmark, bookmarking }
}

export default useAddToBookmarks
